'use client';
import { CarrierListItem } from '@bw/external-apis';
import { useState } from 'react';
import { MyContext } from '../../helpers/context';
import { CompaniesSearchBanner } from '../companies-search-banner/CompaniesSearchBanner';
import { SearchResult } from '../search-result/SearchResult';
import { CompaniesWeRepresent } from '@bw/apis/contentful';

interface CompaniesSearchData {
	companiesWeRepresentPage: CompaniesWeRepresent['fields'];
	carrierList: CarrierListItem[] | null;
}

export const CompaniesSearch = ({
	companiesWeRepresentPage,
	carrierList,
}: CompaniesSearchData) => {
	const [searchQuery, setSearchQuery] = useState('');
	const [activeAlphabet, setActiveAlphabet] = useState('');
	const contextValue = {
		searchQuery,
		setSearchQuery,
		activeAlphabet,
		setActiveAlphabet,
	};
	return (
		<MyContext.Provider value={contextValue}>
			<CompaniesSearchBanner
				companiesWeRepresentPage={companiesWeRepresentPage}
			/>
			{carrierList && <SearchResult carrierList={carrierList} />}
		</MyContext.Provider>
	);
};
